<div class="c-widget c-quick-order-widget d-none d-sm-flex">
  <div>
    <h3 class="c-widget-title c-heading c-heading-h3">
      {{ 'accountOrders.order_products_label' | cxTranslate }}
    </h3>
    <h6 class="c-heading c-heading-h5 color-secondary">
      {{ 'accountOrders.quick_order_label' | cxTranslate }}
    </h6>
    <p class="text-fixed-legal-copy">
      {{ 'addToCartItems.searchItems' | cxTranslate }}
    </p>
  </div>
  <app-quick-order class="w-100"></app-quick-order>
</div>
